export default {"src":"/_next/static/media/profile-details.04e71acb.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};